import React from 'react';
import logo from '../assests/img/sbse-logo.jpg';
import nitilogo from '../assests/img/niti-logo.jpeg';
import mobilelogo from '../assests/img/logo-mobile.jpg';

import Topmenuleft from './Topmenuleft';
import { Link } from 'react-router-dom';
import { useState, useEffect } from "react";
import Mobilemenu from './Mobilemenu';
import { IoMdClose } from "react-icons/io";


function Header() {
  const [isDarkMode, setIsDarkMode] = useState(false);

  useEffect(() => {
    if (isDarkMode) {
      document.body.classList.add("menu-open");
    } else {
      document.body.classList.remove("menu-open");
    }
  }, [isDarkMode]);


  return (
    <>
      <header>
      <div className='container'>
        <div className='row'>
         
          <div className='col-md-2 main-logo-box'>
          <Link to='/' className='logo-img-box'>
            <img className='main-logo' src={logo}/>    
            <p>Offical Website</p>        
            </Link>

            <Link to='/' className='logo-img-box-mobile'>
            <img className='main-logo-mobile' src={logo}/>
            </Link>
             <h1>State Board of Secondary Education, Delhi</h1>

           <button className='menu-toggle-btn' onClick={() => setIsDarkMode(!isDarkMode)}>
           {/* <CiMenuFries />  */}<span class="menu-title">Menu</span>
           </button>

          </div>
           <div className='col-md-8 center-header-col'>
           <h1>State Board of Secondary Education, Delhi</h1>
           <h2>A Universities Approved & Affiliated Board</h2>
           <p>Regd. by Government of NCT of Delhi</p>
           <p>AN INTERNATIONAL ACCREDITED BOARD BY</p>
           <p>INTERNATIONAL ACCREDITATION ORGANIZATION (IAO), USA</p>
           <p>AN ISO 9001:2008 Certified Board</p>
          </div>


          <div className='col-md-2 right-header-col'>
            <img className='ngo' src={nitilogo}/>   
             <Link className='btn btn-danger' to='/login'>Login</Link>
          </div>
        </div>
      </div>

      <div className='mobile-menu'>
      <button className='menu-close-btn' onClick={() => setIsDarkMode(!isDarkMode)}>
      <IoMdClose />
          </button>
        <Mobilemenu/>
      </div>
    
      </header>

      <div className='main-navigation'>
        <div className='container'>
                 <Topmenuleft/>  
                 </div>
      </div>
     
      </>
  )

}

export default Header;
